import * as React from 'react';
import { TYPOGRAPHY_SIZE, TypographySize } from 'mm-theme-configuration/dist/consts';
import { css } from 'aphrodite/no-important';
import { SemanticTagDataProps, SemanticTagProps, SemanticTagThemeProps, getStyleBySize } from '../semanticTags/semanticTags.utils';
import { useTheme } from '../../theming/useTheme';

export const SpanComponent: React.FunctionComponent<SemanticTagProps> = props => {
  const defaultFontSize = TYPOGRAPHY_SIZE.NORMAL as TypographySize;
  const { children, fontSizesStyles, styles = [], fontSizeSmall = defaultFontSize, fontSizeMedium = defaultFontSize, fontSizeLarge = defaultFontSize } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, { fontSizeSmall, fontSizeMedium, fontSizeLarge });

  return (
    <span className={css(styleBySize, ...styles)}>{children}</span>
  );
};

const mapThemeProps = (theme: SemanticTagThemeProps) => {
  return {
    fontSizesStyles: theme.fontSizesStyles,
  };
};

export const Span: React.FunctionComponent<SemanticTagDataProps> = props => {
  const { styles, ...additionalProps } = props;
  const themeContext = useTheme(mapThemeProps);
  return <SpanComponent styles={styles} {...themeContext} {...additionalProps} />;
};
